export default __webpack_public_path__ + "static/media/step-group-nobg.bec13b94.svg";